import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import type { Job } from '@/types/entities'

interface JobDeleteDialogProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    job: Job | null
    onConfirm: () => void
    isLoading?: boolean
}

export function JobDeleteDialog({
    open,
    onOpenChange,
    job,
    onConfirm,
    isLoading = false,
}: JobDeleteDialogProps) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Delete Job</DialogTitle>
                    <DialogDescription>
                        Are you sure you want to delete "{job?.name}"? This action cannot be undone.
                        The job will be permanently removed and any scheduled executions will be cancelled.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter>
                    <Button
                        variant="outline"
                        onClick={() => onOpenChange(false)}
                        disabled={isLoading}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="destructive"
                        onClick={onConfirm}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Deleting...' : 'Delete'}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}



